/**
 * Tipos de item de cobrança por horas (contrato).
 *
 * `SemDiferenciacao` (36) é a modalidade absoluta introduzida pelos tickets
 * MIL-26286/MIL-27853/MIL-27854: uma única configuração válida para qualquer
 * hora (interna ou externa, dentro ou fora do expediente). Não deve ser
 * confundida com `InternoOuExterno` (7) e `InternoOuExternoForaExpediente` (29),
 * que continuam sendo modalidades diferenciadas por período.
 *
 * O identificador 36 é definido em conjunto com o backend e está centralizado
 * aqui — não deve ser espalhado como literal.
 */
export enum TipoItemCobrancaHoraEnum {
  InternoOuExterno = 7,
  Interno = 8,
  Externo = 9,
  InternoOuExternoForaExpediente = 29,
  InternoForaExpediente = 30,
  ExternoForaExpediente = 31,
  SemDiferenciacao = 36,
}

/** Modalidades diferenciadas por período/origem da hora. */
export const TIPOS_ITEM_COBRANCA_HORA_DIFERENCIADOS: number[] = [
  TipoItemCobrancaHoraEnum.InternoOuExterno,
  TipoItemCobrancaHoraEnum.InternoOuExternoForaExpediente,
  TipoItemCobrancaHoraEnum.Interno,
  TipoItemCobrancaHoraEnum.InternoForaExpediente,
  TipoItemCobrancaHoraEnum.Externo,
  TipoItemCobrancaHoraEnum.ExternoForaExpediente,
];

/** Versão de consumo dos contratos que utilizam a nova experiência de cobrança por horas. */
export const VERSAO_CONSUMO_CONTRATO_V2 = 2;

/** Indica se o contrato deve utilizar a nova experiência (V2) de cobrança por horas. */
export function isContratoConsumoV2(versaoConsumo: any): boolean {
  return Number(versaoConsumo) === VERSAO_CONSUMO_CONTRATO_V2;
}

/**
 * Regra única de "ilimitado" de um item de cobrança por horas (mesma regra da API, MIL-30081):
 * - sem limite (`possui_limite = false`) e tipo diferente de 36; ou
 * - sem limite, tipo 36 (Sem Diferenciação) e valor extra 0 ou nulo; ou
 * - com limite, quantidade 00:00 e valor extra 0 ou nulo.
 */
export function itemCobrancaHoraIlimitado(item: {
  tipo_item_cobranca_id?: number | null;
  possui_limite?: boolean | string | null;
  total_itens_contrato?: string | number | null;
  valor_por_item_excedente?: number | string | null;
}): boolean {
  if (!item) {
    return false;
  }

  const semValorExtra =
    item.valor_por_item_excedente === null ||
    item.valor_por_item_excedente === undefined ||
    item.valor_por_item_excedente === "" ||
    Number(item.valor_por_item_excedente) === 0;

  if (item.possui_limite === false || item.possui_limite === "false") {
    return Number(item.tipo_item_cobranca_id) !== TipoItemCobrancaHoraEnum.SemDiferenciacao || semValorExtra;
  }

  if (item.possui_limite === true || item.possui_limite === "true") {
    const digitos = (item.total_itens_contrato === null || item.total_itens_contrato === undefined
      ? ""
      : item.total_itens_contrato.toString()).replace(/\D/g, "");

    return (digitos.length === 0 || Number(digitos) === 0) && semValorExtra;
  }

  return false;
}
